module.exports = __webpack_public_path__ + "static/media/r-md16.8209c9cf.png";